import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { getLatestArticles } from "@/lib/content";
import ArticleCard from "@/components/feature/ArticleCard";

export default function LatestFeed() {
  const latest = getLatestArticles(5);
  const editors = [articles[3], articles[7], articles[9]];
  const tagPool = Array.from(new Set(articles.flatMap((item) => item.tags))).slice(0, 12);

  return (
    <section className="bg-background-100 border-b border-background-200">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-8">
            <div className="flex items-end justify-between mb-8">
              <div>
                <p className="text-xs tracking-[0.18em] text-primary-600 mb-2.5">最新更新</p>
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">看点内容流</h2>
              </div>
              <Link to="/today" className="inline-flex items-center gap-1.5 text-sm text-foreground-700 hover:text-primary-700 whitespace-nowrap transition-colors">
                全部看点 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="flex flex-col gap-8 md:gap-10">
              {latest.map((item) => (
                <div key={item.id} className="pb-8 md:pb-10 border-b border-background-200 last:border-b-0 last:pb-0">
                  <ArticleCard article={item} variant="wide" />
                </div>
              ))}
            </div>
          </div>

          <aside className="lg:col-span-4 flex flex-col gap-8">
            <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
              <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950 pb-3 border-b border-background-200">
                <i className="ri-article-line text-secondary-600"></i>
                编辑推荐
              </h3>
              <div className="mt-1">
                {editors.map((item, index) => (
                  <ArticleCard key={item.id} article={item} variant="minimal" rank={index + 1} />
                ))}
              </div>
            </div>

            <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
              <h3 className="flex items-center gap-2 text-base font-semibold text-foreground-950 pb-4 border-b border-background-200">
                <i className="ri-price-tag-3-line text-accent-600"></i>
                热门标签
              </h3>
              <div className="mt-4 flex flex-wrap gap-2">
                {tagPool.map((tag) => (
                  <Link
                    key={tag}
                    to={`/today?q=${encodeURIComponent(tag)}`}
                    className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-700 hover:border-primary-300 hover:text-primary-700 transition-colors"
                  >
                    {tag}
                  </Link>
                ))}
              </div>
            </div>

            <div className="rounded-lg bg-secondary-100 border border-secondary-200 p-5 md:p-6">
              <h3 className="text-base font-semibold text-secondary-900">关于筛选取舍</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-secondary-900/85">
                我们只呈现与公开作品、公开活动相关的内容，不传播未经核实的信息。每条看点都会标注更新时间，方便你自行判断。
              </p>
              <Link to="/about" className="mt-4 inline-flex items-center gap-1.5 text-sm text-secondary-800 hover:gap-2.5 transition-all">
                了解我们的内容原则 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}